import React from 'react';
import { SortableElement, SortableHandle } from "react-sortable-hoc";
import Input from "../Input";
import UploadButton from '../UploadButton';

const Draggable = SortableHandle((props) => {
    return (
        <div className="drag-point">
            <i className="fas fa-sort"></i>
        </div>
    )
});

const Sortable = SortableElement(props => {
        return (
            <div className="sortable-item col-6">
                <div className="d-flex">
                    <div>
                        <Draggable {...props} />
                        <div className="delete-point" index={props.itemIndex} onClick={props.deleteButtonHandler}>
                            <i className="far fa-trash-alt"></i>
                        </div>
                    </div>

                    <div className="d-flex flex-column w-100">
                        <div className="form-group">
                            <label>Name</label>
                            <Input name={`elements.${props.itemIndex}.name`} value={props.element.name} onChange={props.onChange}/>
                        </div>
                        <div className="form-group">
                            <label>Position</label>
                            <Input name={`elements.${props.itemIndex}.position`} value={props.element.year} onChange={props.onChange}/>
                        </div>
                        <div className="form-group d-flex">
                            <div>
                                <label>Изображение</label>
                                <div className="images">
                                    <div className="img-container">
                                        <div className="img-wrap">
                                            <img src={props.element.img}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pt-3">
                                <UploadButton name={`elements.${props.itemIndex}.img`}
                                              index={props.itemIndex} onChange={props.onChange}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
);

export default Sortable;
